import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/think-peaks': {
    width: 529,
    height: 512,
    paths: [
      {
        d: 'M236.2 0L442.4 353.9 497.5 258.9 529.5 259.2 442.4 409.4 236.2 55.6 32 407.7 0 407.4 236.2 0zM472.5 512L236.7 107.4 87.1 365.3H119.2L236.6 162.8 440 511.9'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/think-peaks.js
// module id = OHvK
// module chunks = 144